import { useCallback } from 'react';

import { TranslatableText } from '@dreryk/react-common';
import { Button, ButtonVariant, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { appointmentsTranslationKeys, visitTranslationKeys } from '../../../../translations';

type ShowVisitButtonProps = {
   readonly visitId: number | undefined;
   readonly patientId: number;
   readonly label?: TranslatableText;
   readonly backActionLabel?: TranslatableText;
   readonly disabled?: boolean;
   readonly variant?: ButtonVariant;
};

export const ShowVisitButton = (props: ShowVisitButtonProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(true);
   const handleClick = useCallback(() => {
      push(
         visitPaths.getVisitHistoryPath({
            params: {
               patientId: props.patientId,
            },
            searchParams: {
               visitId: props.visitId,
            },
         }),
         {
            label: props.backActionLabel ?? visitTranslationKeys.goBackToAppointmentsList,
         }
      );
   }, [push, props.patientId, props.visitId, props.backActionLabel]);

   return (
      <Button
         label={props.label ?? appointmentsTranslationKeys.show}
         type={'button'}
         onClick={handleClick}
         testId={'showVisit'}
         disabled={props.disabled}
         variant={props.variant}
      />
   );
};
